export const MIN_VOLUME_VALUE_ON_UNMUTE_SOUND = 5;
